import React, { useState } from "react";

function ColorCircle({ colorClass, isSelected, onClick }) {
  const getStyle = () => {
    if (!colorClass) return { background: "transparent" };
    if (colorClass.includes("transparent")) return { background: "transparent" };

    const colorVar = colorClass.replace("z-", "--z-");
    return { background: `var(${colorVar})` };
  };

  return (
    <div
      title={colorClass}
      onClick={() => onClick(colorClass)}
      className={`zcc_color_circle ${isSelected ? "zcc_color_circle__selected" : ""}`}
      style={getStyle()}
    >
      {colorClass.includes("transparent") && (
        <div
          style={{
            width: 16,
            height: 16,
            backgroundColor: "white",
            border: "1px solid #ccc",
            borderRadius: "100%"
          }}
        />
      )}
    </div>
  );
}

export default function ColorSwatchSelector({ group, selectedClass, onChange }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (cls) => {
    if (cls === selectedClass) {
      onChange("");
    } else {
      onChange(cls);
    }
  };

  const groupOrder = ["primary", "secondary", "success", "warning", "danger", "gradient"];
  return (
    <div className={"border_full border_radius_medium bg_light"} style={{ padding: 12 }}>
      <div onClick={() => setIsOpen(!isOpen)} className="d_flex justify_between align_center cursor_pointer">
        <h3 className={"font_weight_semibold"}>{group.label}</h3>
        <div
          title={selectedClass}
          style={{
            width: 20,
            height: 20,
            borderRadius: "100%",
            border: "1px solid #ccc",
            ...(selectedClass
              ? selectedClass.includes("transparent")
                ? { background: "transparent" }
                : { background: `var(${selectedClass.replace("z-", "--z-")})` }
              : {})
          }}
        />
      </div>

      {isOpen && (
        <>
          <div style={{ margin: "12px 0", height: 1, backgroundColor: "#E5E7EB" }} />
          <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 20 }}>
            {/* Transparent */}
            {group.options.transparent && (
              <div>
                <p style={{ fontSize: 12, fontWeight: 500, color: "#6b7280", marginBottom: 4 }}>Transparent</p>
                <div style={{ display: "flex", gap: 8 }}>
                  {group.options.transparent.map((opt) => (
                    <ColorCircle
                      key={opt.class}
                      colorClass={opt.class}
                      isSelected={selectedClass === opt.class}
                      onClick={handleSelect}
                    />
                  ))}
                </div>
              </div>
            )}

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                columnGap: 16,
                rowGap: 20
              }}
            >
              {groupOrder.map((groupKey) =>
                group.options[groupKey] ? (
                  <div key={groupKey}>
                    <p
                      style={{
                        fontSize: 12,
                        fontWeight: 500,
                        color: "#6b7280",
                        marginBottom: 4,
                        textTransform: "capitalize"
                      }}
                    >
                      {groupKey}
                    </p>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                      {group.options[groupKey].map((opt) => (
                        <ColorCircle
                          key={opt.class}
                          colorClass={opt.class}
                          isSelected={selectedClass === opt.class}
                          onClick={handleSelect}
                        />
                      ))}
                    </div>
                  </div>
                ) : null
              )}
            </div>

            {group.options.neutral && (
              <div>
                <p style={{ fontSize: 12, fontWeight: 500, color: "#6b7280", marginBottom: 4 }}>Neutral</p>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                  {group.options.neutral.map((opt) => (
                    <ColorCircle
                      key={opt.class}
                      colorClass={opt.class}
                      isSelected={selectedClass === opt.class}
                      onClick={handleSelect}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
